import React, { useEffect } from 'react'
import { Card, TextField, CardContent, Button, FormControl, Grid, MenuItem } from '@mui/material';

import { LinearLoading, CustomAutocomplete, CustomLoading } from '../../../../common'

export const FormOperations = ({ useFetchInit }) => {

    const {
        globalStates,
        Forms,
        FetchData,
        Actions
    } = useFetchInit

    const { modalOpeningMode, loadingSubmitForm } = globalStates

    const { FormScreen } = Forms
    const { formState, onInputChange, onSelectSearchChange } = FormScreen
    
    const { fetchAllCashRegisters } = FetchData
    const { dataCashRegisters, loadingFetchCashRegisters } = fetchAllCashRegisters

    const {
        onSubmitForm,
        handleClickHideForm
    } = Actions

    useEffect(() => {
        
        fetchAllCashRegisters.setParamsToSearch({
            currency_type: formState.currency_type
        })
        fetchAllCashRegisters.executeFetch()

    }, [formState.currency_type])

    return (
        <Card style={{zIndex:'1'}}>
            <CardContent>
                <div className='h4 mt-1 mb-1'>
                    {formState.idmovimiento > 0
                        ? 'Informacion de Registro'
                        : 'Crear Registro'}
                </div>
                <div className="border-bottom border-dark"></div>
                {/* {loadingFetchSpecificTransactionCashier && ( <LinearLoading /> )} */}

                <div className="pt-3"></div>
                <p className='text-danger'>* campos obligatorios</p>
                <div className="pt-2"></div>

                <form onSubmit={onSubmitForm}>
                    <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <FormControl fullWidth>
                                <label htmlFor="fecha_operacion">* Fecha</label>
                                <TextField
                                    id='fecha_operacion'
                                    name='fecha_operacion'
                                    value={ formState.fecha_operacion }
                                    onChange={ onInputChange }
                                    size='small'
                                    placeholder='Fecha'
                                    type='date'
                                    variant='filled'
                                    hiddenLabel
                                    InputProps={{
                                        readOnly: false
                                    }}
                                    required
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <FormControl fullWidth>
                                <label htmlFor="currency_type">* Tipo</label>
                                <TextField
                                    id="currency_type"
                                    name="currency_type"
                                    value={formState.currency_type}
                                    onChange={onInputChange}
                                    select
                                    size="small"
                                    variant="outlined"
                                    hiddenLabel
                                    InputProps={{ 
                                        readOnly: false
                                    }}
                                >
                                    <MenuItem value='QUETZAL'>QUETZAL</MenuItem>
                                    <MenuItem value='DOLAR'>DOLAR</MenuItem>
                                </TextField>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <div className="pt-4"></div>
                    <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <FormControl fullWidth>
                                <label htmlFor="idcaja">* Caja</label>
                                {(loadingFetchCashRegisters)&&(<LinearLoading/>)}
                                <CustomAutocomplete 
                                    customId="idcaja"
                                    customName="idcaja"
                                    customValue={formState.idcaja}
                                    customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'idcaja', value: value.value }})}
                                    customPlaceholder='Seleccionar opción'
                                    customOptions={
                                        dataCashRegisters.map(({ idcaja, descripcion_corta, currency_type, categoria }) => ({
                                            value: idcaja,
                                            name: `${descripcion_corta} - ${currency_type} - ${categoria}`
                                        }))
                                    }
                                    customDisableClearable={true}
                                    customDisabled={(modalOpeningMode==='READONLY')}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>

                    <div className="pt-4"></div>
                    {(loadingSubmitForm)&&(<CustomLoading/>)}
                    <Grid container>
                        <Grid item>
                            <div className='update ml-auto mr-auto'>
                                <Button
                                    style={{background: "#4b4b4c"}}
                                    variant="contained"
                                    type='submit'
                                    disabled={(modalOpeningMode==='READONLY') || loadingSubmitForm}
                                >
                                    <i className="fa-regular fa-floppy-disk"></i> &nbsp; Guardar
                                </Button>
                                &nbsp; &nbsp;
                                <Button
                                    style={{ marginRight: 2, marginLeft: 2, background: "#ef8157" }}
                                    type='button'
                                    variant="contained"
                                    onClick={handleClickHideForm}
                                    disabled={loadingSubmitForm}
                                >
                                    <i className="fa-regular fa-circle-left"></i> &nbsp; Cancelar
                                </Button>
                            </div>
                        </Grid>
                    </Grid>
                </form>
            </CardContent>
        </Card>
    )
}
